import { render, staticRenderFns } from "./UploadBox.vue?vue&type=template&id=268b5252&scoped=true"
import script from "./UploadBox.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadBox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UploadBox.vue?vue&type=style&index=0&id=268b5252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268b5252",
  null
  
)

export default component.exports